import { Separator } from "@/components/ui/separator";
import { Fuel } from "lucide-react";
import RatePresets from "@/components/RatePresets";
import { Field, OvernightSection, BackhaulSection, BonusSection } from "@/components/CostExtras";

export default function CostInputs({
  cost,
  setCost,
  overnight,
  setOvernight,
  suggestOvernight,
  backhaul,
  setBackhaul,
  bonus,
  setBonus,
  fuelMarket,
}) {
  const upd = (k) => (v) => setCost({ ...cost, [k]: v });
  const marketPrice = fuelMarket?.gulf_coast ?? fuelMarket?.us;

  return (
    <div className="bg-white border border-border rounded-lg shadow-sm p-5 space-y-5">
      <div className="flex items-center gap-2">
        <Fuel className="h-4 w-4 text-[#F97316]" />
        <h3 className="text-sm font-bold uppercase tracking-[0.1em] text-[#1C1917]">
          In-House Cost Inputs
        </h3>
      </div>

      <RatePresets cost={cost} setCost={setCost} />

      <div className="grid grid-cols-2 gap-3">
        <Field label="Truck MPG (towing)" value={cost.mpg} onChange={upd("mpg")} testid="input-mpg" />
        <div>
          <Field label="Fuel $/gal" value={cost.fuelPrice} onChange={upd("fuelPrice")} prefix="$" testid="input-fuel" />
          {marketPrice != null && (
            <div className="flex items-center gap-1.5 mt-1" data-testid="fuel-market-hint">
              <span className="text-[11px] text-[#57534E]">
                Market ({fuelMarket.gulf_coast != null ? "Gulf Coast" : "US"}): <b className="text-[#1C1917]">${marketPrice.toFixed(2)}</b>/gal · DOE weekly
              </span>
              <button
                type="button"
                onClick={() => upd("fuelPrice")(String(marketPrice))}
                className="text-[11px] font-bold text-[#EA580C] hover:underline"
                data-testid="fuel-market-use-button"
              >
                Use
              </button>
            </div>
          )}
        </div>
        <Field label="Driver wage $/hr" value={cost.wage} onChange={upd("wage")} prefix="$" testid="input-wage" />
        <Field label="Avg speed mph" value={cost.avgSpeed} onChange={upd("avgSpeed")} testid="input-speed" />
        <Field label="Wear & tear $/mi" value={cost.wearTear} onChange={upd("wearTear")} prefix="$" testid="input-weartear" />
        <Field label="Stop time (min)" value={cost.stopTimeMin} onChange={upd("stopTimeMin")} suffix="min" testid="input-stoptime" />
        <Field label="Margin %" value={cost.marginPct} onChange={upd("marginPct")} suffix="%" testid="input-margin" />
        <Field label="Broker market $/mi (one-way)" value={cost.brokerRatePerMile} onChange={upd("brokerRatePerMile")} prefix="$" testid="input-brokerrate" />
        <Field label="Broker margin % (optional)" value={cost.brokerMarginPct ?? ""} onChange={upd("brokerMarginPct")} suffix="%" testid="input-broker-margin" />
      </div>

      <Separator />
      <OvernightSection overnight={overnight} setOvernight={setOvernight} suggestOvernight={suggestOvernight} />
      <Separator />
      <BackhaulSection backhaul={backhaul} setBackhaul={setBackhaul} />
      <Separator />
      <BonusSection bonus={bonus} setBonus={setBonus} />
    </div>
  );
}
